import { isFunction } from 'lodash';
var hideRemoveButton = function hideRemoveButton(count, index) {
  var customHideRemoveButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  if (isFunction(customHideRemoveButton)) {
    return customHideRemoveButton();
  }
  return index === 0 && count <= 1;
};
export default hideRemoveButton;